import {
	COLORS,
	fontFamily,
	RADIUS,
	SHADOWS,
	Text,
	Spacings,
	Devices,
	Sizes
} from '../base/indexV2'

export const LightThemeV2 = {
	colors: {
		// page & card surfaces
		surface: {
			page:    COLORS.neutral[100],  // app background
			card:    COLORS.neutral[0],    // card, table background
			overlay: COLORS.neutral[100],  // table header, sidebar
			sunken:  COLORS.neutral[100],  // input background
		},

		// text hierarchy
		text: {
			primary:   COLORS.neutral[800],  // headings, important data
			secondary: COLORS.neutral[500],  // labels, helper text
			disabled:  COLORS.neutral[300],  // disabled state
			inverse:   COLORS.neutral[0],    // text on dark background
			link:      COLORS.blue.default,  // clickable links
		},

		// borders & dividers
		border: {
			default: COLORS.neutral[200],   // table rows, card borders
			strong:  COLORS.neutral[300],   // focused inputs, separators
			focus:   COLORS.blue.default,   // focused state
		},

		// brand
		brand: {
			primary:  COLORS.blue.default,
			hover:    COLORS.blue.emphasis,
			subtle:   COLORS.blue.subtle,
			muted:    COLORS.blue.muted,
		},

		// status — used for pills, badges, alerts
		status: {
			success: {
				bg:     COLORS.green.subtle,
				text:   COLORS.green.emphasis,
				border: COLORS.green.muted,
				icon:   COLORS.green.default,
			},
			warning: {
				bg:     COLORS.yellow.subtle,
				text:   COLORS.yellow.emphasis,
				border: COLORS.yellow.muted,
				icon:   COLORS.yellow.default,
			},
			error: {
				bg:     COLORS.red.subtle,
				text:   COLORS.red.default,
				border: COLORS.red.muted,
				icon:   COLORS.red.default,
			},
			info: {
				bg:     COLORS.blue.subtle,
				text:   COLORS.blue.emphasis,
				border: COLORS.blue.muted,
				icon:   COLORS.blue.default,
			},
			neutral: {
				bg:     COLORS.neutral[100],
				text:   COLORS.neutral[400],
				border: COLORS.neutral[200],
				icon:   COLORS.neutral[300],
			},
			orange: {
				bg:     COLORS.orange.subtle,
				text:   COLORS.orange.emphasis,
				border: COLORS.orange.muted,
				icon:   COLORS.orange.default,
			},
			celeste: {
				bg:     COLORS.celeste.subtle,
				text:   COLORS.celeste.emphasis,
				border: COLORS.celeste.muted,
				icon:   COLORS.celeste.default,
			},
			fog: {
				bg:     COLORS.fog.subtle,
				text:   COLORS.fog.emphasis,
				border: COLORS.fog.muted,
				icon:   COLORS.fog.default,
			},
		},

		// layout
		layout: {
			sidebar:    COLORS.navy,
			sidebarText: COLORS.white,
		},
	},

	fontFamily,
	radius: RADIUS,
	shadows: SHADOWS,
	Text,
	Spacings,
	Devices,
	Sizes,
}
